import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { FC } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { Message } from "shared/components/Message";
import { ErrorIdentifier } from "./ErrorIdentifier";
import { fatalErrorMessages } from "./errorMessages";
import styles from "./ErrorPage.module.scss";

type Props = {
    errorIdentifier?: React.ReactNode;
};

export const ErrorPage: FC<Props> = ({
    errorIdentifier,
}) => {
    return (
        <main aria-labelledby="errorPage-heading">
            <Card className={classNames("rounded-bottom", styles.errorCard)}>
                <CardHeader className={classNames("rounded-0", styles.errorHeader)}>
                    {
                        <div className={styles.title}>
                            <Row>
                                <Col>
                                    <h1 className="h5" id="errorPage-heading">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;<span role="alert"><Message message={fatalErrorMessages.defaultTitleLabel} /></span>
                                    </h1>
                                </Col>
                            </Row>
                        </div >
                    }
                </CardHeader>
                <CardBody>
                    <Message message={fatalErrorMessages.defaultInstructionsLabel} />
                    <div aria-live="polite" aria-atomic="true" className="sr-only">
                        {errorIdentifier && <Message message={fatalErrorMessages.generatedErrorIdentifierLabel} />}
                    </div>
                    <div>
                        {errorIdentifier}
                    </div>
                </CardBody>
            </Card>
        </main>
    );
};

export {
    ErrorIdentifier,
    fatalErrorMessages
};

